import LazyLoad from 'vanilla-lazyload';
import {
	setBlogMenuState,
	initSearchBar,
} from '../../components/blog/functions';

const initLazyLoad = new LazyLoad();
initLazyLoad.update();

setBlogMenuState();

// Initialize search bar passing topics nav item as querySelector to hide it when search is open
initSearchBar('.topics-nav-item');

/**
 * Scroll progress bar
 */
const postContent = document.querySelector('.article');
window.onscroll = () => {
	const winScroll =
		document.body.scrollTop || document.documentElement.scrollTop;
	const height =
		postContent.scrollHeight - document.documentElement.clientHeight;
	const scrolled = (winScroll / height) * 100;
	document.querySelector('.progress-bar').style.width = `${scrolled}%`;
};

/**
 * Copy to clipboard
 */
const copyLink = document.querySelector('.copy-to-clipboard');
const copiedTextElement = copyLink.querySelector('span');
copyLink.addEventListener('click', (e) => {
	e.preventDefault();
	navigator.clipboard.writeText(copyLink.getAttribute('url')).then(() => {
		copiedTextElement.classList.remove('invisible');
		setTimeout(() => {
			copiedTextElement.classList.add('invisible');
		}, 2000);
	});
});

const bottomCTA = document.querySelector('.bottom-cta');
const closeBottomCTA = document.getElementById('close-cta');
closeBottomCTA.addEventListener('click', (e) => {
	e.preventDefault();
	bottomCTA.style.transition =
		'transform 0.2s ease-out, opacity 0.2s ease-out';
	bottomCTA.style.transform = 'translateY(100%)';
	bottomCTA.style.opacity = '0';
	setTimeout(() => {
		bottomCTA.remove();
	}, 200);
});

/**
 * Table of contents
 */

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.toc a').forEach((anchor) => {
		anchor.addEventListener('click', (e) => {
			e.preventDefault();
			const targetId = anchor.getAttribute('href');
			const targetElement = document.querySelector(targetId);

			if (targetElement) {
				window.scrollTo({
					top: targetElement.offsetTop - 100,
					behavior: 'smooth',
				});
			}
		});
	});
});
